angular
	.module 'App.Directive'
	.directive 'imageViewer', (ImageService) ->
		scope:
			image: '='
			allowEdit: '<?'
			callback: '&?'
		restrict: 'AE'
		replace: 'true',
		template:
			'<div class="thumb-container" ng-class="{editable: allowEdit}">
				<span class="camera-icon icon icon-camera background-icon"></span>
				<input
					type="file"
					class="file-input"
					accept="image/png, image/jpeg, image/webp, image/avif"
					ng-disabled="!allowEdit"
				>
				<div class="thumb-image"></div>
				<div ng-show="image && allowEdit" class="remove">
					<span class="icon icon-trash"></span>
				</div>
			</div>'
		link: (scope, element) ->
			scope.allowEdit ?= true

			fileInput = element.find('.file-input')
			thumb = element.find('.thumb-image')

			onImageError = =>
				thumb
					.css {backgroundImage: ''}
					.closest '.thumb-container'
					.addClass 'image-error'

			setImage = (url) =>
				thumb
					.closest '.thumb-container'
					.removeClass 'image-error'

				if url? && url != ''
					url = ImageService.resize(url)

					thumb.css {backgroundImage: 'url(' + url + ')'}

					img = new Image()
					img.src = url
					img.onerror = onImageError
				else
					onImageError()

			fileInput.change ->
				files = fileInput[0].files

				if files && files[0]
					reader = new FileReader()
					reader.onload = (e) ->
						setImage e.target.result

						scope.callback?({file: files[0], url: e.target.result})
						scope.$apply ->
							scope.image = files[0]

					reader.readAsDataURL files[0]

			thumb.click ->
				fileInput.click()

			element
				.find('.remove')
				.click ->
					scope.image = ''
					fileInput.val(null)

					setImage null

					scope.callback?({file: null, url: null})

			scope.$watch 'image', ->
				if angular.isUndefined(scope.image) || !scope.image
					setImage null
					return

				if scope.image instanceof File
					reader = new FileReader()
					reader.onload = (e) ->
						setImage e.target.result
					reader.readAsDataURL scope.image
				else
					setImage scope.image
